<template>
    <div class="contaner">
       <Alert :message='marketsError' type="alert-danger" v-if="marketsError" />
        <div class="row">
          <div class="col-12">
            <a href="#" class="btn btn-success  my-3" style="float:right"
                data-toggle="modal" data-target="#addMarket">
                <i class="fas fa-trash">   </i> Add Market 
            </a>
          </div>
        </div>
        <div class="row">
            <div class="col">
            <div class="card border-left-danger">
                <div class="card-body">
                <div class="row">
                    <div class="col">
                    <p class="my-5 text-center"></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                    <div class="card">
                        <div class="card-body">
                        <div class="table-responsive">
                            <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                            >
                            <thead>
                                <tr>
                                <th>Market Name</th>
                                <th>Actions</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                <td></td>
                                <td>
                                    <a href="#" class="btn btn-success btn-circle mr-3"
                                        data-toggle="modal" data-target="#updateMarket">
                                        <i class="fas fa-trash">   </i>
                                    </a>
                                    <a href="#" class="btn btn-danger btn-circle"
                                        data-toggle="modal" data-target="#deleteMarket">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                <th>Name</th>
                                <th>Actions</th>
                                </tr>
                            </tfoot>
                            </table>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
      <!--add market modal content -->
      <div class="modal fade" id="addMarket" tabindex="-1" aria-labelledby="add market" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Market </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <Alert v-bind:message='success' type='alert-success' v-if="success"/>
              <Alert v-bind:message="addError" type="alert-danger" v-if="addError" />
              <form @submit.prevent="addMarket">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Market Name:</label>
                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="name" required>
                  </div>
                  <button type="submit" class="btn btn-danger" style="float:right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- end of modal content -->
         <!-- modal content -->
      <div class="modal fade" id="updateMarket" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Update Market </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <Alert v-bind:message='success' type='alert-success' v-if="success"/>
              <Alert v-bind:message="addError" type="alert-danger" v-if="addError" />
              <form @submit.prevent="addMarket">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Market Name:</label>
                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="name" required>
                  </div>
                  <button type="submit" class="btn btn-danger" style="float:right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- end of modal content -->
       <!-- delete modal  content -->
      <div class="modal fade" id="deleteMarket" tabindex="-1" aria-labelledby="Delete Market" aria-hidden="true">
        <div class="modal-dialog">  6vt
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Confirm Delete</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <Alert v-bind:message='success' type='alert-success' v-if="success"/>
                <Alert v-bind:message="addError" type="alert-danger" v-if="addError" />
                <button style="float:right" class="btn btn-danger">delete</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of delete modal content -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name:'Markets',
    data() {
      return {
        name:null,
        success:null,
        addError:null,
        marketsError:null
      }
    },
    methods: {
         addMarket() {
          const data = {
            name:this.name
          }

          this.$store.dispatch('addMarket',data)
            .then(response => {
                if(response.status === 201) {
                  this.success = 'Market created successfully.'
                }
            }).catch(err => {
              if(err?.response?.data === undefined) {
                this.addError = 'Network error.'
              }
            })
        },
        getMarkets() {
          this.$store.dispatch('getAllMarktes')
            .catch(err => {
              if(err?.response?.data === undefined) {
                this.marketsError = 'Network Error.'
              }
            })

        }
        
    },
    computed: { ...mapGetters(["markets"]) },
    created() {
          console.log('markets from component', this.markets)
        },
}
</script>